import BaseModel from './BaseModel';

export default class QrMenuProduct extends BaseModel {
   getId() {
      return this.get('id');
   }
}
